import type { EntryPointComponent } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { Route } from '@atlassian/react-resource-router';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { getNavigationSidebarGlobalSettingsResources } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LegacyComponentEntryPointContainer } from '@jira/router-routes__common/src/LegacyComponentEntryPointContainer.tsx';
import { workflowDesignerRoute } from '@jira/router-routes__legacy-workflow-designer-routes/src/workflowDesignerRoute.tsx';
import { LegacyWorkflowDesigner } from './hasNavigatedViaDefault.tsx';

const workflowDesignerExperimentalEntryPoint = createPageEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-LegacyWorkflowDesignerEntryPointRoot-entrypoint" */ './LegacyWorkflowDesignerEntryPointRoot.tsx',
			{ entryFsSsrLiftImportToModule: true },
		),
		getPreloadProps: () => ({}),
	},
});

export const workflowDesignerRouteEntry: Route = createEntry(workflowDesignerRoute, () => ({
	// eslint-disable-next-line no-restricted-syntax
	component: fg('nike_entrypoint_migration_batch_10') ? undefined : LegacyWorkflowDesigner,

	layout: globalSettingsLayout,

	navigation: {
		sidebarId: SidebarIdGlobalIssuesSettings,
	},

	resources: [
		...getNavigationResources(),
		navigationSidebarGlobalResource,
		...getNavigationSidebarGlobalSettingsResources(),
	],

	bifrost: {
		bifrostGroup: 'shell-only',
	},

	entryPoint: () =>
		fg('nike_entrypoint_migration_batch_10') ? workflowDesignerExperimentalEntryPoint : undefined,
	entryPointContainer: fg('nike_entrypoint_migration_batch_10')
		? LegacyComponentEntryPointContainer
		: undefined,
}));
